/* eslint-disable */
import { UPLOAD_TIMETABLE_CSV, GET_TIMETABLE_CSV_LIST, GET_ACTIVE_EXAM_LIST, GET_TIME_TABLE_DETAILS_BY_EXAM_ID, LOOKUP_OPTION, GET_LANGUAGE_DATAILS, ADD_EXAM_TIME_TABLE, DELETE_TIME_TABLE_DETAIL, DOWNLOAD_UPLOADED_TIME_TABLE_ERROR_FILE, ADMIT_CARD_TEMPLATE, GET_ALL_REQUISITION_LOOKUP_OPTION_DROPDOWN, GET_EXAM_TEMPLATE_LIST_FOR_IMPORT_ADMIT_CARD_CSV, GET_EXAM_CENTER_LIST, UPDATE_EXAM_TIME_TABLE, DELETE_EXAM_INSTRUCTIONS_DETAIL, GET_EXAM_INSTRUCTIONS_DATA, GET_SELECT_EXAM_LISTING, GET_DELETED_DATA, GET_DATA_BY_EXAM_TEMPLATE} from "../../common/constants/endpoints";
import API from "../../helpers/API";
import { SET_UPLOAD_TIME_TABLE_CSV, GET_UPLOAD_TIME_TABLE_CSV_LIST, SET_TIME_TABLE_CSV_LIST_PAGE_NO_COUNTER, GET_ACTIVE_EXAM_LIST_DETAILS, GET_TIME_TABLE_DETAILS_BY_EXAM, SET_EXAM_TYPE_FOR_TIME_TABLE, SET_LANGUAGE_DETAILS_FOR_TIME_TABLE, SET_UPLOAD_TIME_TABLE_CSV_RESPONSE, SET_EXAM_LIST_DETAILS_FOR_OBJECTION_REPORT, SET_ADMIT_CARD_TEMPLATE_DROPDOWN, SET_EXAM_TEMPLATE_LIST_FOR_IMPORT_ADMIT_CARD_CSV, SET_EXAM_CENTER_LIST, GET_UPDATE_EXAM_TIME_TABLE_DATA, GET_TIME_TABLE_DETAILS_BY_TEMPLATE_ID, GET_TIME_TABLE_LISTING, GET_DATA_EXAM_TEMPLATE} from '../../common/constants/ActionTypes';
import { toastr } from 'react-redux-toastr';
import { hideLoader, showLoader } from "../../common/actions/commonActions";
import FileDownload from "js-file-download";

export const uploadTimeTableCsv = (data, stageId, errorfilename,examcenterid, templateid) => {
    const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
    let token = session.jwtResponse && session.jwtResponse.token
    let formData = new FormData();
    if (data.file) {
        formData.append('file', data.file);
    }
    if (data.action == "upload") {
        formData.append('showOnlySummary', true);
    }
    if (data.action == "save") {
        formData.append('showOnlySummary', false);
    }
    let response;
    let header = {
        'Authorization': `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
        "Accept": "application/json",
        "type": "formData",
    }

    return async (dispatch) => {
        try {
            dispatch(showLoader());
            response = await API.post(UPLOAD_TIMETABLE_CSV + `?stageid=${stageId}` + `&errorfilename=${errorfilename}` + `&examcenterid=${examcenterid}` + `&templateid=${templateid}`, formData, {
                headers: header
            });
            if (response.data) {
                dispatch({
                    type: SET_UPLOAD_TIME_TABLE_CSV_RESPONSE,
                    payload: response.data
                })
                if (data.action == "save") {
                    dispatch(resetTimeTableList());
                }
                let errorMessage = (response && response.data && response.data.errorInUploadedFile) ?
                response.data.message : response.data.message;
                if(errorMessage === "There is error in uploaded file, kindly download the file for more details."){
                    toastr.error(errorMessage)
                }else{
                    toastr.success(errorMessage);
                }
            }
            if (response != null) {
                dispatch(hideLoader());
            }

        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    }
};

export const resetTimeTableList = () => {
    return async (dispatch) => {
        dispatch({
            type: GET_UPLOAD_TIME_TABLE_CSV_LIST,
            payload: []
        })
    }
};

export const getTimetableCsvList = (pageNumber, rowPerPage, advtId) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.get(GET_TIMETABLE_CSV_LIST + `${pageNumber}` + `/${rowPerPage}` + `?advid=${advtId}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            if (response?.data?.timeTableDtoList?.length > 0) {
                dispatch({
                    type: GET_UPLOAD_TIME_TABLE_CSV_LIST,
                    payload: response?.data
                });
                dispatch({
                    type: SET_TIME_TABLE_CSV_LIST_PAGE_NO_COUNTER,
                    payload: (pageNumber * rowPerPage),
                });
            }
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }

    };
};

export const getActiveExamList = (advtId) => {
    return async (dispatch) => {
        dispatch(showLoader());
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            if(advtId && advtId !== undefined){
            response = await API.get(GET_ACTIVE_EXAM_LIST + `?advid=${advtId}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            }else{
                response = await API.get(GET_ACTIVE_EXAM_LIST, {
                    headers: { Authorization: `Bearer ${token}` },
                });
            }
            dispatch({
                type: GET_ACTIVE_EXAM_LIST_DETAILS,
                payload: response.data,
            });
            dispatch({
                type: SET_EXAM_LIST_DETAILS_FOR_OBJECTION_REPORT,
                payload: response.data,
            });
            if (response != null) {
                dispatch(hideLoader());
            }
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    }
};

export const getTimeTableDetailsByAdvtId = (adverId) => {
    return async function (dispatch) {
        dispatch(showLoader());
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let pageNumber = 0;
        let rowPerPage = 10;
        let response;
        try {
            response = await API.get(GET_EXAM_INSTRUCTIONS_DATA + `/${pageNumber}` + `/${rowPerPage}` + `?advid=${adverId}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            if (response?.data?.examInstructionsDtoList?.length > 0) {
                dispatch({
                    type: GET_TIME_TABLE_DETAILS_BY_EXAM,
                    payload: response?.data
                });
                if (response != null) {
                    dispatch(hideLoader());
                }

            }
            if(response?.data?.examInstructionsDtoList?.length === 0){
                dispatch(hideLoader());
            }
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }

    };
};

export const getExamTypeForTimeTable = () => {
    return async (dispatch) => {
        try {
            // eslint-disable-next-line no-useless-concat
            let response = await API.get(LOOKUP_OPTION + `?module=exam_creation` + `&type=exam_pattern`);
            if (response && response.data) {
                dispatch({
                    payload: response.data,
                    type: SET_EXAM_TYPE_FOR_TIME_TABLE
                });
            }
        } catch (error) {
            let errorMessage = ""
            if (error.response && error.response.data) {
                errorMessage = error.response.data.message;
            } else {
                errorMessage = error.message;
            }
        }
    }
};

export const getLanguageDetailsForTimeTable = () => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.get(GET_LANGUAGE_DATAILS, {
                headers: { Authorization: `Bearer ${token}` },
            });
            if (response && response.data) {
                dispatch({
                    payload: response.data,
                    type: SET_LANGUAGE_DETAILS_FOR_TIME_TABLE
                });
            }
        }
        catch (error) {
            let errorMessage = ""
            if (error.response && error.response.data) {
                errorMessage = error.response.data.message;
            } else {
                errorMessage = error.message;
            }
        }
    }
};

// export const addExamTimeTable = (requestData, advtId) => {
//     return async function (dispatch) {
//         const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
//         let token = session.jwtResponse && session.jwtResponse.token;
//         let response;
//         let examId = requestData && requestData.timeTableExamsDtoList && requestData.timeTableExamsDtoList[0].selectedExam;
//         try {
//             response = await API.post(ADD_EXAM_TIME_TABLE, requestData, {
//                 headers: { Authorization: `Bearer ${token}` },
//             });
//             toastr.success(response.data.message);
//             dispatch(getTimeTableDetailsByAdvtId(advtId));
//             dispatch(getExamTemplateListForImportAdmitCardCsvAPI(examId));
//         } catch (error) {
//             let errorMessage = (error.response && error.response.data) ?
//                 error.response.data.message : error.message
//             toastr.error(errorMessage);
//             return;
//         }
//     };
// };

export const addExamTimeTable = (requestData,advtId,selectedExam,flagexisting=false,getdataExamTemplate) => {
    
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        // let examId = requestData && requestData.timeTableExamsDtoList && requestData.timeTableExamsDtoList[0].selectedExam;
        try {
            if(flagexisting && getdataExamTemplate!=="No record found for id: 0"){
                response = await API.patch(ADD_EXAM_TIME_TABLE, requestData, {
                    headers: { Authorization: `Bearer ${token}` },
                });
            }else{

                response = await API.post(ADD_EXAM_TIME_TABLE, requestData, {
                    headers: { Authorization: `Bearer ${token}` },
                });
            }
            toastr.success(response.data.message);
            if(advtId){
                dispatch(getTimeTableDetailsByAdvtId(advtId));
            }
            dispatch(getExamTemplateListForImportAdmitCardCsvAPI(selectedExam));
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
};

export const updateExamTimeTable = (requestData,advtId) => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        let examId = requestData && requestData.timeTableExamsDtoList && requestData.timeTableExamsDtoList[0].selectedExam;
        try {
            response = await API.patch(ADD_EXAM_TIME_TABLE, requestData, {
                headers: { Authorization: `Bearer ${token}` },
            });
            let successMessage = (response && response.data) ? response.data.message : response.message
            toastr.success(successMessage);
            dispatch(getTimeTableDetailsByAdvtId(advtId));
            dispatch(getExamTemplateListForImportAdmitCardCsvAPI(examId));
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        };
    };
};

export const deleteTimeTableDetailById = (requestData, adverId) => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.patch(DELETE_TIME_TABLE_DETAIL, requestData, {
                headers: { Authorization: `Bearer ${token}` },
            });
            let successMessage = (response && response.data) ? response.data.message : response.message
            toastr.success(successMessage);
            dispatch(getTimeTableDetailsByAdvtId(adverId));
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        };
    };
};

export const getTimetableCsvErrList = (errorfilename, file) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.get(DOWNLOAD_UPLOADED_TIME_TABLE_ERROR_FILE  + `?errorfilename=${errorfilename}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            if (response?.data) {
                // dispatch({
                //     type: GET_UPLOAD_TIME_TABLE_CSV_LIST,
                //     payload: response?.data
                
                // });
                FileDownload(response.data, `${errorfilename}.csv`);
            }
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }

    };
};

export const admitCardSampleCsvDownload = () => {
    return async () => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        const token = session.jwtResponse && session.jwtResponse.token;

        let response;
        try {
            response = await API.get(ADMIT_CARD_TEMPLATE,
                {
                    headers: { 'Authorization': `Bearer ${token}` },
                    responseType: 'blob',
                }
            );
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                JSON.parse(await error.response.data.text()).message : error.message
            toastr.error(errorMessage);
            return;
        }

        FileDownload(response.data, `AdmitCardTemplate.csv`);
    }
};

export const setAdmitCardTemplateDropdown = () => {
    return async (dispatch) => {
        try {
            let response = await API.get(LOOKUP_OPTION + `?module=exam_creation&type=admitcard_template`, {
            });

            dispatch({
                payload: (response && response.data) ? response.data : [],
                type: SET_ADMIT_CARD_TEMPLATE_DROPDOWN
            });
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ? error.response.data.message
                : error.message;

            toastr.error(errorMessage);
        }

    }
};

export const getExamTemplateListForImportAdmitCardCsvAPI = (examId) => {
    const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
    let token = session.jwtResponse && session.jwtResponse.token;
    let examid = examId ? examId : "";
    return async (dispatch) => {
        try {
            let response = await API.get(GET_EXAM_TEMPLATE_LIST_FOR_IMPORT_ADMIT_CARD_CSV + `?examid=${examid}`, {
                headers: { Authorization: `Bearer ${token}` },
            });

            dispatch({
                payload: (response && response.data) ? response.data : [],
                type: SET_EXAM_TEMPLATE_LIST_FOR_IMPORT_ADMIT_CARD_CSV
            });
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ? error.response.data.message
                : error.message;

            toastr.error(errorMessage);
        }

    }
};

export const getExamCenterListAPI = (advtId) => {
    const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
    let token = session.jwtResponse && session.jwtResponse.token;

    return async (dispatch) => {
        try {
            let response = await API.get(GET_EXAM_CENTER_LIST + `?advid=${advtId}`, {
                headers: { Authorization: `Bearer ${token}` },
            });

            dispatch({
                payload: (response && response.data) ? response.data : [],
                type: SET_EXAM_CENTER_LIST
            });
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ? error.response.data.message
                : error.message;

            toastr.error(errorMessage);
        }

    }
};

export const getUpdateExamTimeTableDataAPI = (id, exid, templateid) => {
    const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
    let token = session.jwtResponse && session.jwtResponse.token;

    return async (dispatch) => {
        try {
            let response = await API.get(UPDATE_EXAM_TIME_TABLE + `?id=${id}` + `&exid=${exid}` + `&templateid=${templateid}`, {
                headers: { Authorization: `Bearer ${token}` },
            });

            dispatch({
                payload: (response && response.data) ? response.data : [],
                type: GET_UPDATE_EXAM_TIME_TABLE_DATA
            });
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ? error.response.data.message
                : error.message;

            toastr.error(errorMessage);
        }

    }
};

export const deleteExamInstructionsDetailsById = (requestData, adverId) => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.patch(DELETE_EXAM_INSTRUCTIONS_DETAIL, requestData, {
                headers: { Authorization: `Bearer ${token}` },
            });
            let successMessage = (response && response.data) ? response.data.message : response.message
            toastr.success(successMessage);
            dispatch(getTimeTableDetailsByAdvtId(adverId));
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        };
    };
};

export const getTimeTableDetailsByTemplateId = (adverId, templateId, examid,venueid, updateIsVenueAssigned=()=>{},timeTableExamIds=[]) => {
    return async function (dispatch) {
        dispatch(showLoader());
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        let examId = examid ? examid : '';
        let venueId = venueid ? venueid : '';
        try {
            response = await API.get(GET_TIME_TABLE_DETAILS_BY_EXAM_ID + `/${adverId}` + `?examid=${examId}` + `&venueid=${venueId}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            // if ((response?.data?.templateId==templateId) && (response?.data?.timeTableExamsDtoList?.length > 0)) {
            if ( (response?.data?.timeTableExamsDtoList?.length > 0)) {
            dispatch({
                    type: GET_TIME_TABLE_DETAILS_BY_TEMPLATE_ID,
                    payload: response.data
                });
                timeTableExamIds.length> 0 && updateIsVenueAssigned(response?.data, timeTableExamIds)

                if (response != null) {
                    dispatch(hideLoader());
                }

            }else{
                dispatch({
                    type: GET_TIME_TABLE_DETAILS_BY_TEMPLATE_ID,
                    payload: []
                });
            }
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }

    };
};


export const getselectExamListing = (examid, showall) => {
    return async (dispatch) => {
        dispatch(showLoader());
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        let showallFlg = showall ? showall : "";
        try {
            response = await API.get(GET_SELECT_EXAM_LISTING+ `?exid=${examid}` + `&showall=${showallFlg}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            if (response && response.data) {
                dispatch({
                    payload: response.data,
                    type: GET_TIME_TABLE_LISTING
                });
                toastr.success(response.data.message);
            }
            if (response != null) {
                dispatch(hideLoader());
            }
        }
        catch (error) {
            dispatch(hideLoader());
            let errorMessage = ""
            if (error.response && error.response.data) {
                errorMessage = error.response.data.message;
                toastr.error(errorMessage)
            } else {
                errorMessage = error.message;
                toastr.error(errorMessage)
            }
        }
    }
};

export const deletingData = (requestData) => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.patch(GET_DELETED_DATA, requestData,{
                headers: { Authorization: `Bearer ${token}` },
            });
            if (response && response.data) {
                toastr.success(response.data.message);
            }
        }
        catch (error) {
            let errorMessage = ""
            if (error.response && error.response.data) {
                errorMessage = error.response.data.message;
            } else {
                errorMessage = error.message;
            }
        }
    }
};


export const fetchingDataOnTemplate = (examid,value) => {
    return async (dispatch) => {
        dispatch(showLoader());
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        const token = session?.jwtResponse?.token; // Use optional chaining to safely access properties
        try {
            const response = await API.get(GET_DATA_BY_EXAM_TEMPLATE+`?exid=${examid}`+`&templateid=${value}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            if (response && response.data) {
                dispatch({
                    payload: response.data,
                    type: GET_DATA_EXAM_TEMPLATE
                });
            }
            if (response != null) {
                dispatch(hideLoader());
            }
        } catch (error) {
            dispatch(hideLoader());
            let errorMessage = "";
            if (error.response && error.response.data) {
                errorMessage = error.response.data.message;
                
            } else {
                errorMessage = error.message;
            }
            toastr.error(errorMessage);
            dispatch({
                payload: errorMessage,
                type: GET_DATA_EXAM_TEMPLATE
            }); // Display error message using toastr
        }
    };
};
